import { connect } from 'react-redux';
import { switchLocale } from 'redux/actions/layoutActions';
import Locale from './Locale';

const mapStateToProps = ({ layout }) => {
    const { locale } = layout;
    return { locale };
};

export default connect(mapStateToProps, { switchLocale })(Locale);
